
import Modal from "components/UI/organisms/Modal"
import { Flex, Text, FormControl, Image, Box, Checkbox, InputRightElement, InputGroup, InputLeftElement, Spinner } from "@chakra-ui/react"
import Button from "components/UI/atoms/Button"
import Input from "components/UI/atoms/Input"
import FormLabel from "components/UI/atoms/FormLabel"
import Select from "components/UI/atoms/Select"
import Icon from "components/UI/atoms/Icon"
import moment from "moment"


import { useUI } from "providers/UIProvider"
import { useLaundryContext } from "providers/LaundryProvider/LaundryProvider"
import { ICarBodyType, ICarWashType } from "types/laundry"
import GEO from "assets/country_flags/georgia.png"
import { IWashType } from "types/reservation"
import useReservations from "hooks/useReservations"
import CompanyBranchesForReservations from "components/shared/CompanyBranches/CompanyBranchesReservations"
import { useReservationsContext } from "providers/ReservationsProvider/ReservationsProvider"
import { useAppContext } from "providers/AppProvider/AppProvider"
import { IRoles } from "types/shared"



const webReservationsModal = () => {

  const { userRole } = useAppContext();

  const isQappUser = userRole && [IRoles.QAPP_ADMIN, IRoles.QAPP_MANAGER].includes(userRole);

  const { carWashScheduleData, discountTypesData, carWashWashers, carWashBoxes, createWebReservationLoading } = useReservationsContext();
  const { modals, toggleModal, T, lang } = useUI();
  const { laundry } = useLaundryContext();

  const { form: {
    errors,
    handleBlur,
    handleChange,
    touched,
    values,
    handleSubmit,
  }, selectedBodyType,
    selectedService,
    selectedDiscountTypeId,
    selectedSchedule,
    selectedDay,
    selectedHour,
    isDiscount,
    selectedBox,
    selectedWasher,
    setSelectedBox,
    selectWashDay,
    selectWashHour,
    handleBodyType,
    handleService,
    handleDiscountType,
    setIsDiscount,
    setSelectedWasher,
    setFieldValue,

  } = useReservations()


  const bodyTypes: ICarBodyType[] = laundry?.bodyTypes || []
  const washTypes: ICarWashType[] = bodyTypes[0]?.washTypes || []


  const generateServicesOpitons = () => washTypes.map((service: IWashType) => ({
    label: service.name,
    value: service.id
  }))

  const generateBodyTypesOptions = () => bodyTypes.map((bodyType) => ({
    label: bodyType.name,
    value: bodyType.id
  }))


  const generateDiscountTypesData = () =>
    discountTypesData?.map((discount: { name: string; id: number }) => ({
      label: discount.name,
      value: discount.id,
    }))


  const boxCount = carWashBoxes


  const generateWashersData = () => {
    return carWashWashers?.map(((carWash: { box: number, washerEmployeeId: number, washerEmployee: string }) => {
      return {
        label: carWash.washerEmployee,
        value: carWash.washerEmployeeId
      }
    }))
  }



  const generateBoxOptions = (quantity: number) => (
    [
      {
        label: "No Box",
        value: 0
      },
      ...Array.from({ length: quantity }, (_v, i: number) => ({
        label: `#${i + 1}`,
        value: i + 1
      }))
    ]
  );


  const formatPhoneNumber = (value: string) => {
    // Remove all non-numeric characters
    const digits = value.replace(/\D/g, "");

    // Add formatting based on the number of digits
    let formatted = digits;
    if (digits.length > 3) {
      formatted = `${digits.slice(0, 3)}-${digits.slice(3)}`;
    }
    if (digits.length > 5) {
      formatted = `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
    }
    if (digits.length > 7) {
      formatted = `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5, 7)}-${digits.slice(7, 9)}`;
    }

    return formatted;
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedValue = formatPhoneNumber(e.target.value);
    setFieldValue("mobileNumber", formattedValue); // Update the value in Formik
  };

  // E X A M P L E
  // const DiscountPercentsArray = [
  //   { value: 10, label: "10%" },
  //   { value: 20, label: "20%" },
  //   { value: 30, label: "30%" },
  //   { value: 40, label: "40%" },
  //   { value: 50, label: "50%" },
  //   { value: 60, label: "60%" },
  //   { value: 70, label: "70%" },
  //   { value: 80, label: "80%" },
  //   { value: 90, label: "90%" },
  //   { value: 100, label: "100%" }
  // ]

  // const generateDiscountPercents = () => DiscountPercentsArray.map((option) => ({
  //   value: option.value,
  //   label: option.label,
  // }))


  moment.locale(lang)


  const onWheel = (e: any) => {
    e.stopPropagation();
  } // fixes scrolling behavior 


  return (
    <>
      <Modal
        isOpen={modals.webReservationsModal.isOpened}
        onClose={() => toggleModal("webReservationsModal", false)}
        title={T("bookings.create.reservation")}
        closeButtonIcon="red-close"
        closeIconStyles={{ width: "33px", height: "33px", fill: "#7D90A8" }}
        styles={{
          width: "35.375rem",
          headerPadding: "10px 15px 10px 23px",
          height: "96%"
        }}
        closeOnOverlayClick={false}
        blockScrollOnMount={false}
      >
        <Flex onWheel={onWheel} onTouchMove={onWheel} gap={25} flexDirection="column" height="lg">
          <Flex flexDirection="column" gap="10px" borderBottom={"1px solid #E9F2FD "} paddingBottom="25px">
            <Flex gap="8px" paddingLeft="4px" paddingTop="10px">
              <Checkbox borderColor="black"
                size="lg"
                isChecked={isDiscount}
                onChange={() => setIsDiscount(!isDiscount)} />
              <Text style={{ fontWeight: "500px", fontSize: "16px" }}>{T("bookings.discount")}</Text>
            </Flex>
            <Flex gap="16px">
              {isDiscount && <FormControl width={"100%"}>
                <Select
                  width="50px"
                  value={selectedDiscountTypeId || ""} /////
                  onChange={handleDiscountType}
                  options={generateDiscountTypesData()}
                  inputStyles={{
                    fontSize: "var(--chakra-fontSizes-m)",
                    height: "60px",
                  }}
                  placeholder={T("bookings.discount.type")}
                  styles={{
                    singleValue: (base: any) => ({
                      ...base,
                      fontWeight: "bold"
                    }),
                    menuList: (base: any) => ({
                      ...base,
                      fontWeight: "bold"
                    }),
                    placeholder: (base: any) => ({
                      ...base,
                      fontWeight: "bold",
                      color: "black"
                    }),
                  }}

                />
              </FormControl>}
              <FormControl width={"100%"}>
                <Select
                  width="50px"
                  value={selectedService || ""}
                  onChange={handleService}
                  options={generateServicesOpitons()}
                  inputStyles={{
                    fontSize: "var(--chakra-fontSizes-m)",
                    height: "60px",
                  }}
                  styles={{
                    singleValue: (base: any) => ({
                      ...base,
                      fontWeight: "bold"
                    }),
                    menuList: (base: any) => ({
                      ...base,
                      fontWeight: "bold"
                    }),
                    placeholder: (base: any) => ({
                      ...base,
                      fontWeight: "bold",
                      color: "black"
                    }),
                  }}
                />
              </FormControl>
            </Flex>
          </Flex>
          <Flex gap={10} borderBottom={"1px solid #E9F2FD "} paddingBottom="25px">
            <FormControl width="100%">
              <FormLabel id="auto" text={T("bookings.car.type")} style={{ fontWeight: "bold" }} />
              <Select
                value={selectedBodyType || ""}
                onChange={handleBodyType}
                options={generateBodyTypesOptions()}
                inputStyles={{
                  height: "60px",
                }}
                placeholder={bodyTypes[0]?.name}
                // placeholderStyles={{ fontSize: "var(--chakra-fontSizes-m)" }}
                styles={{
                  singleValue: (base: any) => ({
                    ...base,
                    fontWeight: "bold"
                  }),
                  menuList: (base: any) => ({
                    ...base,
                    fontWeight: "bold"
                  }),
                  placeholder: (base: any) => ({
                    ...base,
                    fontWeight: "bold",
                    color: "black"
                  }),
                }}
              />
            </FormControl>
            <FormControl width="100%" >
              <FormLabel id="auto" text={T("bookings.car.number")} style={{ fontWeight: "bold" }} />
              <Flex h="60px" w="241px">
                <Flex
                  backgroundColor={"primary"}
                  alignItems="center"
                  width={"34px"}
                  borderTopLeftRadius="8px"
                  borderBottomLeftRadius="8px"
                  flexDirection={"column"}
                  justifyContent={"space-around"}
                >
                  <Image src={GEO} alt="Flag" w={"18px"} h={"11px"} />
                  <Text lineHeight={"12px"} fontSize={"12px"} color={"white"}>
                    GE
                  </Text>
                </Flex>
                <Box style={{ flexDirection: "column" }}>
                  <Input
                    id="car-number"
                    name="carNumber"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.carNumber && errors.carNumber)}
                    errorMessage={errors.carNumber}
                    type="string"
                    value={values.carNumber.toUpperCase()}
                    borderRadius="8px"
                    borderLeftRadius="0px"
                    borderLeft="0px"
                    borderColor={errors.carNumber ? "#F30028" : "#046CEC"}
                    borderWidth="2px"
                    w="164px"
                    height="60px"
                    fontSize="xxxl"
                    placeholder={T("bookings.gov.number")}
                    _placeholder={{ fontSize: "20px" }}
                  />
                </Box>
              </Flex>
            </FormControl>
          </Flex>
          <Flex gap={10} height="100%" width="100%" whiteSpace="nowrap">
            <FormControl width={isDiscount ? "18%" : "241px"}>
              <FormLabel id="auto" text={T("bookings.price")} style={{ fontWeight: "bold" }} />
              <InputGroup style={{ width: "100%", flexDirection: "column" }}>
                <Input
                  id="washPrice"
                  name="washPrice"
                  type="number"
                  value={values.washPrice}
                  onChange={handleChange}
                  width="239px"
                  height="3.75rem"
                  error={Boolean(touched.washPrice && errors.washPrice)}
                  errorMessage={errors.washPrice}
                  onBlur={handleBlur}
                />
                <InputLeftElement style={{
                  pointerEvents: "none",
                  width: "19px",
                  height: "60px",
                  fontSize: "18px",
                  zIndex: "0"
                }}
                >
                  ₾
                </InputLeftElement>
              </InputGroup>
            </FormControl>
            {isDiscount &&
              <FormControl width={"20%"} isDisabled={selectedDiscountTypeId === undefined}>
                <FormLabel id="auto" text={T("bookings.discount")} opacity="70%" />
                <InputGroup style={{ flexDirection: "column" }} >
                  <Input
                    id="discountPercent"
                    name="discountPercent"
                    type="number"

                    value={values.discountPercent || ""} ////////
                    onChange={handleChange}
                    width="239px"
                    height="3.75rem"
                    // placeholder="100%"
                    error={Boolean(touched.discountPercent && errors.discountPercent)}
                    errorMessage={errors.discountPercent}
                    onBlur={handleBlur}

                  />

                  <InputRightElement style={{
                    pointerEvents: "none",
                    width: "90%",
                    height: "60px",
                    fontSize: "18px",
                    zIndex: "0"
                  }}
                  >
                    %
                  </InputRightElement>
                </InputGroup>
              </FormControl>
            }
            <FormControl width={"241px"}>
              <FormLabel id="auto" text={T("bookings.phone.number")} style={{ fontWeight: "bold" }} />
              <Input
                height="60px"
                value={values.mobileNumber}
                onBlur={handleBlur}
                // error={Boolean(errors.mobileNumber && touched.mobileNumber)}
                // errorMessage={errors.mobileNumber}
                name="mobileNumber"
                id="mobile-number"
                type="text"
                onChange={(e: any) => handlePhoneChange(e)}
                placeholder="XXX-XX-XX-XX"
              />
            </FormControl>
          </Flex>
          <Flex gap={10} height="100%" width="100%" whiteSpace="nowrap">
            <FormControl width={"241px"}>
              <Select
                styles={{ zIndex: 1050, overflowY: "auto" }}
                width="50px"
                value={selectedWasher || ""} /////
                onChange={(e: any) => setSelectedWasher(e.value)}
                options={generateWashersData()}
                inputStyles={{
                  fontSize: "var(--chakra-fontSizes-m)",
                  height: "60px",
                }}
                placeholder={T("bookings.washer")}
                menuPlacement="top"
              />
            </FormControl>

            <FormControl width={"241px"}>
              <Select
                id="box"
                name="box"
                width="50px"
                value={selectedBox || ""} /////
                onChange={(e: any) => {
                  setSelectedBox(e.value)
                }}
                options={generateBoxOptions(boxCount)}
                inputStyles={{
                  fontSize: "var(--chakra-fontSizes-m)",
                  height: "60px",
                }}
                placeholder={T("bookings.box")}
                menuPlacement="top"
              />
            </FormControl>
          </Flex>
          <Flex justifyContent="center" paddingTop="30px">
            {isQappUser ? <Button
              text={T("bookings.continue")}
              onClick={handleSubmit}
              isDisabled={(Object.keys(errors).length !== 0 || Object.keys(touched).length == 0) ||
                (!selectedDiscountTypeId && isDiscount) || (createWebReservationLoading)}
              _hover={{ backgroundColor: "#08BA36" }}
              variant="success"
              styles={{ width: "13.75rem", height: "3.938rem", fontSize: "xxl", }}
              leftIcon={!createWebReservationLoading ? <Icon
                name="confirm"
                iconStyles={{ width: "34px", height: "34px" }}
              /> : <Spinner />

              }
            /> :
              <Button
                text={T("bookings.continue")}
                onClick={() => toggleModal("webReservationsTimesModal", true)}
                isDisabled={(Object.keys(errors).length !== 0 || Object.keys(touched).length == 0) ||
                  (!selectedDiscountTypeId && isDiscount) || (createWebReservationLoading)}
                _hover={{ backgroundColor: "#08BA36" }}
                variant="success"
                styles={{ width: "13.75rem", height: "3.938rem", fontSize: "xxl", }}
                leftIcon={!createWebReservationLoading ? <Icon
                  name="confirm"
                  iconStyles={{ width: "34px", height: "34px" }}
                /> : <Spinner />

                }
              />}

          </Flex>



        </Flex>

      </Modal>


      <Modal
        isOpen={modals.webReservationsTimesModal.isOpened}
        onClose={() => toggleModal("webReservationsTimesModal", false)}
        title={T("bookings.create.reservation")}
        styles={{
          width: "35.375rem",
          headerPadding: "20px 15px 20px 23px",
          height: "96%"
        }}
        closeButtonIcon="red-close"
        closeIconStyles={{ width: "33px", height: "33px", fill: "#7D90A8" }}
      >
        <Flex flexDirection="column" gap={15} height="lg">
          <Flex style={{
            justifyContent: "center",
            marginTop: "0.8rem"
          }}>
            <CompanyBranchesForReservations />
          </Flex>
          <Flex gap={10} >
            {carWashScheduleData?.data.map((item: { date: string, intervals: [{ isActive: boolean, time: string }] }) =>
              <Box
                as="button"
                key={item.date}
                onClick={() => selectWashDay(item)}
                _active={{
                  transform: "scale(0.98)",
                }}
                style={{
                  borderRadius: 10,
                  backgroundColor: selectedDay === item.date ? "#046CEC" : "#E9F2FD",
                  width: "112px",
                  height: "75px",
                }}>
                <Flex flexDirection="column" gap={3} alignItems="center">
                  <Text style={{ color: selectedDay === item.date ? "#FFF" : "#23262E", marginTop: "3px" }}>
                    {moment(item?.date).format("DD MMM")}
                  </Text>
                  <Text style={{ color: selectedDay === item.date ? "#FFF" : "#23262E", fontSize: "13px" }}>
                    {moment(item?.date).format("ddd")}
                  </Text>
                </Flex>
              </Box>
            )}
          </Flex>
          {selectedDay &&
            <Flex>
              <Text style={{ fontSize: "12px", color: "#2E313B" }}>{T("bookings.choose.hour")}</Text>
            </Flex>
          }
          <Flex style={{ gap: 18, flexWrap: "wrap", paddingBottom: "100px" }}>
            {selectedSchedule?.map((item: { time: string, isActive: boolean }) => (

              <Box
                key={item.time}
                as="button"
                _active={{
                  transform: "scale(0.98)",
                }}
                disabled={!item.isActive}
                onClick={() => selectWashHour(item)}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "68px",
                  height: "62px",
                  borderRadius: "10px",
                  backgroundColor: selectedHour === moment(item.time).format() ? "#046CEC" : "#E9F2FD",
                }}>
                <Text style={{ color: selectedHour === moment(item.time).format() ? "#FFF" : "#23262E" }}>
                  {moment(item.time).utc().format("HH:mm")}
                </Text>
                {/* <Text
                      style={{
                        color: selectedHour === moment(item.time).format() ? "#FFF" : "#7D90A8",
                        fontSize: "12px"
                      }}> */}
                {/* {((Number(moment(item.time).format("HH").valueOf()) >= 16) || (Number(moment(item.time).format("HH").valueOf()) <= 3))

                        ? <Text>{"PM"}</Text> : <Text>{"AM"}</Text>} */}

                {/* </Text> */}

              </Box>
            ))}

          </Flex>
          {selectedDay &&
            <Flex
              style={{
                justifyContent: "center",
                paddingBottom: 20,
                position: "absolute",
                bottom: "0",
                left: "30%",
                right: "30%",
              }}>
              {isQappUser ? <Button
                text={T("actions.confirm")}
                isDisabled={selectedHour === null}
                onClick={() => toggleModal("webReservationsModal", true)}
                variant="success"
                styles={{ width: "100%", height: "63px", fontSize: "18px", }}
                _hover={{ backgroundColor: "#08BA36" }}
                leftIcon={
                  <Icon
                    name="confirm"
                    iconStyles={{
                      width: "34px",
                      height: "34px",
                      fill: "white",
                    }}
                  />
                }
              /> : <Button
                text={T("actions.confirm")}
                isDisabled={selectedHour === null}
                onClick={handleSubmit}
                variant="success"
                styles={{ width: "100%", height: "63px", fontSize: "18px", }}
                _hover={{ backgroundColor: "#08BA36" }}
                leftIcon={
                  <Icon
                    name="confirm"
                    iconStyles={{
                      width: "34px",
                      height: "34px",
                      fill: "white",
                    }}
                  />
                }
              />
              }
            </Flex>
          }
        </Flex>

      </Modal>
    </>
  )
}


export default webReservationsModal